
import React from 'react';

import { connect } from 'react-redux';

import moment from 'moment';

import cpdTimeFormatter from '../../services/cpdTimeFormatter';
import eventFormatter   from '../../services/eventFormatter';

import * as detailPageActions from '../../actions/detailPage';

import DetailPage  from '../DetailPage';
import Breadcrumbs from '../Breadcrumbs';
import PageLink    from '../PageLink';

class EventDetailPage extends React.Component {

    componentWillReceiveProps(nextProps) {

        if (this.props.params.eventId !==  nextProps.params.eventId) {

            this.props.refreshData(nextProps.params.eventId);
        }
    }

    _getModuleName() {

        if (this.props.model) {

            return this.props.model.course.module.name;
        }
    }

    _getCourseName() {

        if (this.props.model) {

            return this.props.model.course.name;
        }
    }

    _getOverview() {

        if (this.props.model) {

            return this.props.model.course.description;
        }
    }

    _getPromotionalDetails() {

        if (this.props.model) {

            return this.props.model.course.promotional_details;
        }
    }

    _getTestimonials() {

        if (this.props.model) {

            return this.props.model.course.testimonials;

        } else {

            return [];
        }
    }

    _getCPDHours() {

        if (this.props.model) {

            return cpdTimeFormatter.formatHours(this.props.model.course.cpd_hours);
        }
    }

    _getCPDMinutes() {

        if (this.props.model) {

            return cpdTimeFormatter.formatHours(this.props.model.course.cpd_minutes);
        }
    }

    _getUpcomingEvents() {

        if (this.props.model) {

            return this.props.model.course.upcoming_events;

        } else {

            return [];
        }
    }

    _getFeaturedTestimonial() {

        if (this.props.model) {

            return this.props.model.course.featured_testimonial;

        } else {

            return [];
        }
    }

    _getFormattedEvent() {

        if (this.props.model) {

            return eventFormatter.format(this.props.model);
        }
    }

    getModuleHexColour() {

        if (this.props.model) {

            return this.props.model.course.module.hex_colour;

        } else {

            return '#96afe1';
        }
    }

    _getShortLocation() {

        if (this.props.model) {

            const { address_1, town_city } = this.props.model.venue.address;

            return address_1 + ', ' + town_city;
        }
    }

    _isFullyBooked() {

        if (this.props.model) {

            return this.props.model.fully_booked;
        }
    }

    _isAllowingBookings() {

        if (this.props.model) {

            const currentDate = moment();
            let startDate = currentDate;

            if (this.props.model.multiple_days) {

                let eventStartDate = null;
                this.props.model.multiple_days_events.map((event) => {

                    eventStartDate = moment(event.start_date)

                    if (eventStartDate.isAfter(currentDate)) {
                        startDate = eventStartDate
                    }
                })

            } else {

                startDate   = moment(this.props.model.start_date);
            }

            return this._getUpcomingEvents().length > 0 && (startDate > currentDate);
        }
    }

    _getBreadcrumbs() {

        return (
            <Breadcrumbs>
                <PageLink to="/events">Events</PageLink>
                <PageLink to={ `/events/${ this.props.params.eventId }` }>{ this._getCourseName() }</PageLink>
            </Breadcrumbs>
        );
    }

    _getCourseType() {

        if (this.props.model) {
            return this.props.model.course.type;
        }
    }

    render() {

        return <DetailPage refreshData={ this.props.refreshData.bind(this, this.props.params.eventId) }
                           showResourcePacks={this.props.model && this.props.model.has_resource_packs}
                           moduleHexColour={ this.getModuleHexColour() }
                           courseType={this._getCourseType()}
                           pageType="event"
                           breadcrumbs={ this._getBreadcrumbs() }
                           bookingButtonLink={ `/booking/${ this.props.params.eventId }` }
                           featuredTestimonial={ this._getFeaturedTestimonial() }
                           showVenueAccordion={ true }
                           formattedEvent={ this._getFormattedEvent() }
                           moduleName={ this._getModuleName() }
                           courseName={ this._getCourseName() }
                           courseOverview={ this._getOverview() }
                           testimonials={ this._getTestimonials() }
                           cpdHours={ this._getCPDHours() }
                           cpdMinutes={ this._getCPDMinutes() }
                           allowBookings={ this._isAllowingBookings() }
                           upcomingEvents={ this._getUpcomingEvents() }
                           fullyBooked={ this._isFullyBooked() }
                           shortLocation={ this._getShortLocation() }
                           promotionalDetails={ this._getPromotionalDetails() } />;
    }
}

function mapStateToProps(state) {

    return {
        ...state.detailPage,
        initialValues: {
            code: ''
        }
    };
}

function mapDispatchToProps(dispatch) {

    return {
        refreshData(eventId) {

            dispatch(detailPageActions.refreshEvent(eventId));
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDetailPage);


// WEBPACK FOOTER //
// ./components/EventDetailPage/index.js